import moment from 'moment';
import React from 'react';
import logo from './MP_02.png';
import './report.css';
function getMoment(date = new Date(), tz = 'Asia/Singapore') {
  return moment(date).tz(tz);
}

const Header = () => {
  return (
    <div className="header-detail">
      <img src={logo} style={{ width: 200, height: 30 }} />
      <p
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          lineHeight: 1.5,
          marginBottom: '10px',
          color: 'white',
        }}
      >
        {getMoment(new Date()).format('DD MMM YYYY')}
      </p>
    </div>
  );
};

const Footer = (props) => {
  return (
    <div className="footer-detail">
      <div style={{ marginBottom: '20px' }}>
        <span>Generated by: {props.username}</span>
      </div>
      <div style={{ marginBottom: '20px' }}>
        <span>page {props.page || 1}</span>
      </div>
    </div>
  );
};

export const RecordPledge = (props) => {
  return (
    <div className="page">
      <Header />
      <Footer page={props.page} username={props.user.username} />

      <div className="mt-3 px-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          {' '}
          Selections
        </span>
        {props.users.map((record, i) => (
          <div
            key={'recordPeled-' + i}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.username}
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.email}
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.phone}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export const RecordQuestion = (props) => {
  return (
    <div className="page">
      <Header />
      <Footer page={props.page} username={props.user.username} />

      <div className="mt-3 px-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          {' '}
          Selections
        </span>
        {props.selections.map((record, i) => (
          <div
            key={'record1-' + i}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <p
              className="mt-2 w-2/3"
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {record.title}({record.count})
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              - {record.percentage} %
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export const Question = ({ detailData, page, selections, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />

      <div className="w-full px-4">
        <span
          style={{
            fontSize: '24px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          {' '}
          Question
        </span>
        <p
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
          }}
        >
          {detailData.question}
        </p>
      </div>

      <div className="mt-3 px-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Selections
        </span>
        {selections.map((record, i) => (
          <div
            key={'record-' + i}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <p
              className="mt-2 w-2/3"
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {record.title}({record.count})
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              - {record.percentage} %
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export const Pledged = ({ users, page, data, selections, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />

      <div className="w-full px-4">
        <span
          style={{
            fontSize: '24px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          {' '}
          Pledged Item
        </span>
        {data.totalPledgeAmount > 0 && (
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {selections.length > 0 &&
              selections[0].title + '(' + selections[0].count + ')'}
          </p>
        )}
      </div>
      <div className="w-full flex px-4 mt-3">
        <div className="w-1/2">
          <span
            style={{
              fontSize: '24px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Pledged Amount
          </span>
          {data.totalPledgeAmount > 0 && (
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              S${selections.length > 0 && selections[0].price}
            </p>
          )}
        </div>

        <div className="w-1/2">
          <span
            style={{
              fontSize: '24px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Total
          </span>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            S${data.totalPledgeAmount}
          </p>
        </div>
      </div>
      <div
        className="my-3"
        style={{ width: '100%', height: '1px', background: 'blue' }}
      ></div>
      <div className="mt-3 px-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Selections
        </span>
        {users.map((record, i) => (
          <div
            key={'record-' + i}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.username}
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.email}
            </p>
            <p
              className="mt-2 w-1/3"
              style={{
                fontSize: '20px',
              }}
            >
              {record.phone}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export const PollInfo = ({ page, data, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />
      <div style={{ padding: '0 20px' }}>
        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
          Poll Information Report
        </span>
        <p
          style={{
            fontSize: '20px',
            color: 'blue',
          }}
        >
          {data.title}
        </p>
        <div className="my-3">
          <span
            style={{
              fontSize: '24px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Poll Description
          </span>
          <br />
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
            {data.description}
          </span>
        </div>

        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Poll Period
        </span>
        <div className="w-full flex mb-3">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Start Date
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.start}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              End Date
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.end}
            </p>
          </div>
        </div>
        <span
          className="mt-3"
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Pledge Period
        </span>
        <div className="w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Start Date
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pledgeStart}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              End Date
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pledgeEnd}
            </p>
          </div>
        </div>
        <div
          className="my-3"
          style={{ width: '100%', height: '1px', background: 'blue' }}
        ></div>
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Number of Votes
        </span>
        <p
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
          }}
        >
          {data.numOfVotes}
        </p>
        <div className="mt-16 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Number of Pledges
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.numOfPledges}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Total Pledge Amount
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              S${data.totalPledgeAmount}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
